module.exports = __webpack_public_path__ + "static/img/sass.53e9946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/sass.png
// module id = 9EQx
// module chunks = 0